import { FocAlert } from '@enums/FocAlert'
import { Level } from '@models/Level'

export class LegendParameters {
  constructor(
    public intervals: number[],
    public colors: string[],
    public styleType: Level['styleType'],
    public units?: string,

    public outRangeMin?: boolean,
    public outRangeMax?: boolean,
    public lastIntervalDisabled?: boolean,

    public conversionFunction?: Function
  ) {}

  static fromLevel(level: Level) {
    return new LegendParameters(
      level.intervals,
      level.colors,
      level.styleType,
      level.units,
      level.outRangeMin,
      level.outRangeMax,
      level.lastIntervalDisabled,
      level.conversionFunction
    )
  }

  static alertasFOCParams() {
    const params = new LegendParameters(
      [1, 2, 3, 4].reverse(),
      ['#DCE9EF', '#F6FF6D', '#FF7F00', '#EA3E3E'].reverse(),
      'discrete'
    )

    params.conversionFunction = (i: number) => {
      return FocAlert.getLabel(i)
    }

    return params
  }

  isDiscreteIntervals() {
    return this.styleType === 'discrete'
  }

  isBinaryIntervals() {
    return this.styleType === 'binary'
  }
}
